var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48683 9.77984C8.55216 10.1892 9.1935 10.8378 10.0002 11.8332M7.48683 9.77984C6.1915 9.28184 5.21683 9.15184 4.3335 9.1665M7.48683 9.77984C8.49683 8.66917 9.16016 7.8685 11.6668 7.49984M6.66683 7.1665H6.6675",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5C10.2091 12.5 12 10.7091 12 8.5C12 6.29086 10.2091 4.5 8 4.5C5.79086 4.5 4 6.29086 4 8.5C4 10.7091 5.79086 12.5 8 12.5Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 8.49993C14.6681 9.41758 14.4792 10.3255 14.1122 11.1666M8.00017 15.1666C8.87583 15.1678 9.74309 14.9959 10.5521 14.6608C11.3611 14.3257 12.0959 13.834 12.7142 13.2139M1.3335 8.49993C1.33228 7.62427 1.50416 6.757 1.83927 5.948C2.17438 5.139 2.6661 4.40423 3.28617 3.78592M8.00017 1.83326C7.08251 1.83201 6.17455 2.02086 5.3335 2.38792M5.3335 14.6119C3.79224 13.9382 2.56187 12.7079 1.88817 11.1666M10.5548 2.49992C12.0961 3.17363 13.3265 4.40399 14.0002 5.94526",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.765f80f527e183f13dd312ecc611b511.svg";
export { ForwardRef as ReactComponent };